module.exports.registerCustomSelect = function () {
  if (document.querySelector('.custom-select')) {
    document.querySelector('.custom-select').focus()
    const options = document.querySelectorAll('.custom-option')

    for (const option of options) {
      option.addEventListener('click', function () {
        options.forEach(function (option) {
          option.classList.remove('selected')
        })

        if (!this.classList.contains('selected')) {
          this.classList.add('selected')
          this.closest('.custom-select').querySelector(
            '.custom-select-trigger span'
          ).textContent = this.textContent
          this.closest('.custom-select').querySelector(
            '.custom-select-trigger span'
          ).dataset.value = this.dataset.value
        }
      })
    }

    for (const dropdown of document.querySelectorAll(
      '.custom-select-wrapper'
    )) {
      dropdown.addEventListener('click', function () {
        this.querySelector('.custom-select').classList.toggle('open')
      })
    }

    window.addEventListener('click', function (e) {
      for (const select of document.querySelectorAll('.custom-select')) {
        if (!select.contains(e.target)) {
          select.classList.remove('open')
        }
      }
    })
  }
}
